import { useEffect, useState } from 'react';
import { untilText } from '../lib/format';

/** Живой таймер. Тикает раз в секунду. */
export function Countdown({ to, className = '' }: { to: string | Date | null | undefined; className?: string }) {
  const [, force] = useState(0);
  useEffect(() => {
    const id = setInterval(() => force((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, []);
  return <span className={`font-mono num ${className}`}>{untilText(to)}</span>;
}
